<template>
<div id="component-chat-log" class="">
  <!-- {{tabActive}} -->
  <!-- <pre>{{chatData}}</pre> -->
  <!-- <pre>{{newChatMsg}}</pre> -->
  <ChatSingleDetails v-if="tabActive === 0 || tabActive === 1" :SingleActiveThreadDetails="SingleActiveThreadDetails"></ChatSingleDetails>
  
  <ChatGroupDetails v-if="tabActive === 2"></ChatGroupDetails>

  <VuePerfectScrollbar class="champions-list"  ref="scroll">
  <div class="message-log" :class="{ 'message-log' : tabActive === 2}">
  <vs-row v-for="(each_chat, index) in chatData" :key="index">
    <vs-row v-if="each_chat.sender_user_details.id === current_user_id" class="mb-2 mr-4 p-3" vs-justify="flex-end" vs-align="flex-end" style="min-height:70px;">
      
      <text-container :message="each_chat" v-if="each_chat.is_attachment === 0"/>
      <file-container :message="each_chat" v-if="each_chat.is_attachment === 1"/>

      <vs-button @click="openDeleteChatConfirm(each_chat.id)" class="delete-msg" color="danger" type="flat" icon="delete"></vs-button>

      <!-- <p>Right</p> -->
      <div style="width:60ox;">
        <!-- <vs-avatar size="60px" class="border-2 shadow border-solid border-white m-0 flex-shrink-0" :src="each_chat.receiver_user_details.picture"/> -->
      </div>
    </vs-row>
    <vs-row v-else class="mb-2 p-3" vs-justify="flex-start" vs-align="flex-end" style="min-height:70px;">
      <div style="width:60ox;">
        <!-- {{each_chat}} -->
        <vs-avatar size="40px" class="border-2 shadow border-solid border-white m-0 flex-shrink-0" :src="each_chat.sender_user_details.picture"/>
      </div>
      <text-container :message="each_chat" class="ml-3" v-if="each_chat.is_attachment === 0"/>
      <file-container :message="each_chat" class="ml-3" v-if="each_chat.is_attachment === 1"/>
      <!-- <p>Left</p> -->
    </vs-row>
  </vs-row>
  <vs-row v-if="chatData.length === 0" class="no-msg">
        <h4>No Message</h4>
  </vs-row>
  </div>
  </VuePerfectScrollbar>

  <!-- </vs-row> -->

</div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import textContainer from './textContainer.vue'
import {messageMixin} from './mixin/messageMixin'
import ChatSingleDetails from './ChatSingleDetails.vue'
import ChatGroupDetails from './ChatGroupDetails.vue'
import {EventBus} from './mixin/EventBus'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { fetchChatHistory, deleteChatMessage } from '@/api/message'
import fileContainer from './fileContainer.vue'
import {NotificationMixins} from '@/mixins/common/NotificationMixins.js'

export default {
  name: 'MessageLogs',
  components: {
    VuePerfectScrollbar,
    textContainer,
    ChatSingleDetails,
    ChatGroupDetails,
    fileContainer
  },
  data () {
    return {
      chatData:[],
      current_user_id:'',
      newChatMsg:[]
    }
  },
  mixins:[messageMixin, NotificationMixins],
  mounted () {
    this.current_user_id = JSON.parse(localStorage.getItem('userInfo')).id

    // Listen for the singleChatClicked event and its payload.
    EventBus.$on('singleChatClicked', (chatData) => {
      // 
      this.chatData = chatData.result
    })

    EventBus.$off('newMessageReceived')
    EventBus.$on('newMessageReceived', (chatData) => {
      // console.log('chatData reveived', chatData)
      this.$emit('fetchNewChatData', chatData)
      // console.log(this.UserActiveThread, this.ClientActiveThread, this.GroupActiveThread)

      let active_thread_id = null
      let identifier_key = 'from_user'
      if (this.tabActive === 0) {
        active_thread_id = this.UserActiveThread
        identifier_key = 'from_user'
      } else if (this.tabActive === 1) {
        active_thread_id = this.ClientActiveThread
        identifier_key = 'from_user'
      } else if (this.tabActive === 2) {
        active_thread_id = this.GroupActiveThread
        identifier_key = 'group_id'
      }

      // console.log('active_thread_id', active_thread_id)
      // console.log('identifier_key', identifier_key)

      //Fetching notification list from NotificationMixins
      if (this.chatData.length) {
        if (this.chatData.slice(-1).pop().id !== chatData.id) {
          if (chatData[identifier_key] === active_thread_id) {
            this.fetch_list()
            this.chatData.push(chatData)
          }
        }
      } else {
        console.log('')
        if (chatData[identifier_key] === active_thread_id) {
          this.fetch_list()
          this.chatData.push(chatData)
        }
        
      }
      
      setTimeout(() => {
        this.$refs.scroll.$el.scrollTop  = this.$refs.scroll.$el.scrollHeight
      }, 500)
    })

  },
  computed: {
    ...mapGetters(['ChatRelatedTo', 'chats', 'UserActiveThread', 'ClientActiveThread', 'GroupActiveThread', 'tabActive', 'SingleActiveThreadDetails']),
    messagesWithTime () {
      const formattedMessages = {}
      this.chats.forEach((message) => {
        const messageCreatedMoment = this.$moment.unix(message.message_time)
        let title = ''

        if (messageCreatedMoment.isSame(new Date(), 'day')) {
          title = 'Today'
        } else if (messageCreatedMoment.isSame(new Date(), 'week')) {
          title = messageCreatedMoment.format('ddd')
        } else {
          title = messageCreatedMoment.format('ddd ,MMM DD,YYYY')
        }

        if (formattedMessages[title]) {
          formattedMessages[title].push(message)
        } else {
          formattedMessages[title] = []
          formattedMessages[title].push(message)
        }
      })
      return formattedMessages
    }
  },
  watch: {
    GroupActiveThread: {
      handler (newValue, oldValue) {
        if (newValue !== oldValue) {
          // 
        }
      }
    },
    chatData:{
      handler (newValue, oldValue) {
        if (newValue !== oldValue) {
          setTimeout(() => {
            this.$refs.scroll.$el.scrollTop  = this.$refs.scroll.$el.scrollHeight
          }, 500)
        }
      }
    },
    deep: true
  },
  methods: {
    ...mapActions(['SET_UNREAD_NOTIFICATION_READ']),
    openDeleteChatConfirm (message_id) {
      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: 'Please Confirm',
        text: 'Are you sure about deleting this message ?',
        accept:this.acceptDeleteChatAlert,
        acceptText:'Yes',
        cancelText:'No',
        parameters:[message_id]
      })
    },
    acceptDeleteChatAlert (message_id) {
      this.$vs.notify({
        color:'success',
        title:'Success',
        text:'Chat Deleted'
      })
      this.deleteChatMessage(message_id[0])
    },
    async deleteChatMessage (message_id) {
      try {
        // 
        // 
        
        const payload = {
          chat_id:[message_id]
        }
        const {data} = await deleteChatMessage(payload)
        // 

        try {
          let user_id = null
          let group_id = null
          let to_user_type = ''
          if (this.tabActive === 0) {
            to_user_type = 'User'
            user_id = this.UserActiveThread
          } else if (this.tabActive === 1) {
            to_user_type = 'Client'
            user_id = this.ClientActiveThread
          } else if (this.tabActive === 2) {
            user_id = this.GroupActiveThread
            group_id = user_id
          }

          let payload2 = ''
          if (this.tabActive === 2) {

            payload2 = {
              another_user_id : null,
              from_user_type : 'User',
              group_id,
              last_id : null,
              to_user_type,
              is_client_message_type: this.ChatRelatedTo,
              customer_id:localStorage.getItem('customer_id')
            }

          } else {
            payload2 = {
              another_user_id : user_id,
              from_user_type : 'User',
              group_id: null,
              last_id : null,
              to_user_type,
              is_client_message_type: this.ChatRelatedTo,
              customer_id:localStorage.getItem('customer_id')
            }
          }
          const data2  = await fetchChatHistory(payload2)
          EventBus.$emit('singleChatClicked', data2.data.data)
          this.messageText = ''

        } catch (e) {
          
        }


      } catch (error) {
        
      }
      
    },
    isNextSameUser (messageTime, index) {
      
      if (messageTime.length >= index + 1) {
        if (messageTime[index].user.user_id === messageTime[index + 1].user.user_id) {
          // 
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    }
  }
}
</script>

<style scoped>
.message-log{
  margin-top: 70px;
}

.no-msg{
  display: flex;
  height: 100%;
  align-items: center;
}

.no-msg h4{
  width:100%;
  text-align: center;
}
</style>